import XYZ from 'ol/source/XYZ';
import { ImageryMapSource, IMapSettings } from '@ansyn/imagery';
import { OpenLayersMapSourceProvider } from './open-layers.map-source-provider';
import { OpenLayersMap } from '../maps/open-layers-map/openlayers-map/openlayers-map';
import { OpenLayersDisabledMap } from '../maps/openlayers-disabled-map/openlayers-disabled-map';

export interface IBingMapsConfig {
	key: string;
	styles: string[];
}

export const OpenLayerBingSourceProviderSourceType = 'BING';

@ImageryMapSource({
	sourceType: OpenLayerBingSourceProviderSourceType,
	supported: [OpenLayersMap, OpenLayersDisabledMap]
})
export class OpenLayerBingSourceProvider extends OpenLayersMapSourceProvider<IBingMapsConfig> {
	createSource(metaData: IMapSettings): any {
		const config = { ...this.config, ...metaData.data.config };
		const mapLabelsType = config.style == "AerialWithLabels" ? "imagery.hybrid" : "imagery";
		const source = new XYZ({
			url: `https://atlas.microsoft.com/map/tile?subscription-key=${config.key}&api-version=2.0&tilesetId=microsoft.${mapLabelsType}&zoom={z}&x={x}&y={y}`,
			maxZoom: 19,
			wrapX: true,
			attributions: ['© Microsoft, © OpenStreetMap contributors']
		});
		return source;
	}
}
